import React from 'react'
import Popup from '../Popup'
import Button from '../Button'
import * as Styled from './styled'

interface IWarningPopupProps {
  isOpen: boolean
  title: string
  warningText: React.ReactNode
  confirmButtonText?: string
  cancelButtonText?: string
  onConfirm: () => void
  onCancel: () => void
}

const WarningPopup: React.FC<IWarningPopupProps> = ({
  isOpen,
  title,
  warningText,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  onConfirm,
  onCancel
}) => {
  return (
    <Popup isOpen={isOpen} onClose={onCancel}>
      <Styled.WarningModalContent>
        <Styled.WarningContentFrame>
          <Styled.WarningTitle>{title}</Styled.WarningTitle>

          <Styled.WarningBox>
            <Styled.WarningText>{warningText}</Styled.WarningText>
          </Styled.WarningBox>
        </Styled.WarningContentFrame>

        <Styled.WarningButtonContainer>
          <Button type="white" onClick={onCancel}>
            {cancelButtonText}
          </Button>
          <Button type="primary" onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        </Styled.WarningButtonContainer>
      </Styled.WarningModalContent>
    </Popup>
  )
}

export default WarningPopup
